
import bgImage from '../assets/images/bg.png';
import logo from '../assets/images/logo.webp';
import React, { useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Form } from "reactstrap";
import { useDispatch, useSelector } from 'react-redux';
import { loginUser } from "../redux/actions/userActions";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import CustomInput from '../components/common/customInput.js';
import { RESET_ERROR } from "../redux/constants/userConstants";

export default function Login() {

	const { loginSuccess, error } = useSelector(state => state.auth)

	const [authLoading,setAuthLoading] = useState(true)

    const dispatch=useDispatch();
    const history = useNavigate();

    const schema = yup.object({
		mobilenumber: yup.string().required('Mobile Number is required'),
		password: yup.string()
			.required('No password provided.')
			.min(6, 'Password is too short - should be 6 chars minimum.')
		// .matches(/[a-zA-Z]/, 'Password can only contain Latin letters.')

	}).required()


	const {formState: { errors }, handleSubmit, control } = useForm({
		resolver: yupResolver(schema),
		defaultValues:{
			// role: "admin"
		}
	});
	const onSubmit = (data) => {
		dispatch(loginUser(data))
	};

    
	const checkLogin = async () => {
		let token = await localStorage.getItem("token");

		if (token) {
			history(`${process.env.PUBLIC_URL}/dashboard`);
		}
		else {
			setAuthLoading(false)
		}
	}

    useEffect(() => {
		if (loginSuccess) {
			//navigate to dashboard
			history(`${process.env.PUBLIC_URL}/dashboard`);
			dispatch({
				type: RESET_ERROR
			})
		}

		if (error) {
			//using toast display error message
			dispatch({
				type: RESET_ERROR
			})
		}
	}, [loginSuccess, error])

	useEffect(() => {
		checkLogin()
	}, [])

    return (
        <div
            className="h-screen bg-cover bg-center bg-image bg-slate-200 dark:bg-slate-900"
            style={{ backgroundImage: `url(${bgImage})` }}
        >
            <div className="container mx-auto flex items-center justify-center h-full">
                {/* Black Box */}
                <div className="bg-black bg-opacity-70 p-8 rounded-lg w-[30rem] shadow-lg box-shadow">
                    {/* Logo */}
                    <div className="text-center mb-6">
                        <img src={logo} alt="logo" className="mx-auto w-48 h-auto" />
                    </div>

                    {/* Form */}
                    <Form className="form-horizontal auth-form">
                        {/* Username */}
                        <CustomInput
                                fieldLabel="Mobile Number"
								fieldName={"mobilenumber"}
								placeholder="Mobile Number"
								error={errors.mobilenumber}
								control={control}
								classLableData={"text-white"}
								type={"text"}
                                classData={"w-full px-4 py-2 rounded-md text-black placeholder-gray-400 mb-2 mt-1"}
							/>
							<CustomInput
                                fieldLabel="Password"
								fieldName={"password"}
								placeholder="Password"
								error={errors.password}
								control={control}
								type={"password"}
								classLableData={"text-white"}
                                classData={"w-full px-4 py-2 rounded-md text-black placeholder-gray-400 mb-2 mt-1"}
							/>
                        {/* <div className="mb-2">
                            <label className="block text-white text-sm font-bold mb-2" htmlFor="username">
                                Username
                            </label>
                            <input
                                type="text"
                                id="username"
                                placeholder="Enter your username"
                                className="w-full px-4 py-2 rounded-md bg-gray-800 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#f7e64f] form-control"
                                error={errors.email}
								control={control}
                            />
                        </div> */}

                        {/* Login Button */}
                        <Button
                            type="submit"
                            className="w-full bg-[#fff37a] text-black-800 py-2 rounded-md hover:[#f7e64f] transition duration-200 font-bold mt-2"
                            onClick={handleSubmit(onSubmit)}
                        >
                            Login
                        </Button>
                    </Form>
                </div>
            </div>
        </div>
    )
}